// Limpieza local cuando un técnico pierde el acceso a una orden (C12): se descartan su borrador y
// sus archivos pendientes de esa orden. Solo se invoca tras un rechazo explícito del servidor con
// la sesión revalidada; nunca por errores de red.
import { getDb } from './db.ts';

export async function purgeOrderLocalData(userId: string, orderId: string): Promise<void> {
  const db = await getDb();
  const tx = db.transaction(['drafts', 'queue'], 'readwrite');
  await tx.objectStore('drafts').delete(`${userId}:${orderId}`);
  const queue = tx.objectStore('queue');
  const keys = await queue.index('byUserOrder').getAllKeys([userId, orderId]);
  await Promise.all(keys.map((k) => queue.delete(k)));
  await tx.done;
}
